import { useId } from 'react';

/**
 * The "Mixed doubles" gender chip — purple gradient square with "MIX".
 * Colors are baked in by design (Figma Gender component, variant "Mixed").
 */
export default function GenderMixed({ className }: { className?: string }) {
  const uid = useId().replace(/:/g, '');
  const gradientId = `gender-mixed-gradient-${uid}`;

  return (
    <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id={gradientId}
          x1="16"
          y1="2"
          x2="16"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7167A4" />
          <stop offset="1" stopColor="#63598E" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="28" height="28" rx="3.6" fill={`url(#${gradientId})`} />
      <svg x="5.178" y="11.578" width="9.539" height="8.422" viewBox="0 0 7.155 6.318" fill="none">
        <path
          fill="#FCF2FF"
          d="M7.155 0V6.318H5.616V2.529L4.203 6.318H2.961L1.539 2.52V6.318H0V0H1.818L3.591 4.374L5.346 0H7.155Z"
        />
      </svg>
      <svg x="16.192" y="11.578" width="2.054" height="8.422" viewBox="0 0 1.539 6.318" fill="none">
        <path fill="#FCF2FF" d="M1.539 0V6.318H0V0H1.539Z" />
      </svg>
      <svg x="19.277" y="11.578" width="8.003" height="8.422" viewBox="0 0 6.003 6.318" fill="none">
        <path
          fill="#FCF2FF"
          d="M4.212 6.318L2.925 4.383L1.791 6.318H0.0450001L2.07 3.105L0 0H1.791L3.06 1.908L4.176 0H5.922L3.915 3.186L6.003 6.318H4.212Z"
        />
      </svg>
    </svg>
  );
}
